import styled from 'styled-components';

import { Breadcrumb } from '../../components/Breadcrumb';
import { Button } from '../../components/Button';
import { size } from '../../layout/helpers';

export const Wrapper = styled.div`
  --page-header-gap: ${size(2)};

  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
  align-items: center;
  margin-bottom: max(var(--main-gutter), var(--page-header-gap));
`;

export const PageAlerts = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: ${size(1)};
  margin-bottom: var(--page-header-gap);
`;

export const PageContent = styled.div`
  grid-column: 1 / -1;
  display: flex;
  align-items: flex-start;
  gap: var(--page-header-gap);

  ${(props) => props.theme.breakpoint.LtSm} {
    flex-direction: column;
  }

  ${(props) => props.theme.breakpoint.Sm} {
    justify-content: space-between;

    ${Button} {
      flex-shrink: 0;
    }
  }
`;

export const PageContentText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${size(1.5)};

  ${(props) => props.theme.breakpoint.Lg} {
    //max-width: 50%;
  }
`;

export const Navigation = styled.div`
  grid-column: 1 / -1;

  ${(props) => props.theme.breakpoint.LtMd} {
    display: contents;
  }

  ${(props) => props.theme.breakpoint.Md} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--page-header-gap);
    margin-bottom: var(--page-header-gap);
  }

  ${Breadcrumb} {
    grid-column: 1 / 2;
    font-size: ${(props) => props.theme.font.size.xsmall};

    ${(props) => props.theme.breakpoint.LtMd} {
      margin-bottom: var(--page-header-gap);
    }
  }
`;

export const PageUtility = styled.div`
  grid-column: 2 / 3;
  display: flex;
  align-items: center;
  gap: ${size(1.5)};

  ${(props) => props.theme.breakpoint.Md} {
    gap: ${size(3)};
  }
`;

export const Meta = styled.div`
  min-width: 0;
  margin-top: var(--page-header-gap);
`;

export const Tabs = styled.div`
  grid-column: 1 / -1;
  margin-top: var(--page-header-gap);
`;
